document.addEventListener('DOMContentLoaded', function (){

    let personalizationTextBlock, personalizationText;

    const personalizationTriggerOptions = [
        'color'
    ];

    const personalizationTriggerValues = [
        'custom color'
    ];

    // personalization on product page
    if (document.querySelector('.product-info .personalization-info')){
        setPersonalization();
    }

    function setPersonalization(){
        personalizationTextBlock = document.querySelector('.personalization-info');
        personalizationText = document.querySelector('#personalization-info');
        let productOptions = document.querySelectorAll('.variant-picker__option');

        productOptions.forEach(function (item){

            let optionLabel = item.querySelector('legend').textContent;
            optionLabel = optionLabel.replace(':','');
            if (personalizationTriggerOptions.includes(optionLabel.toLowerCase())) {
                let currentSelected = item.querySelector('input[type="radio"]:checked');
                let optionSelects = item.querySelectorAll(`input[type="radio"][name="${currentSelected.getAttribute('name')}"]`);

                if (personalizationTriggerValues.includes(currentSelected.dataset.value.toLowerCase())) {
                    personalizationTextBlock.classList.add('active');
                }

                personalizationListener(optionSelects);
            } else {
                // listen another option
                let currentSelected = item.querySelector('input[type="radio"]:checked');
                let optionSelects = item.querySelectorAll(`input[type="radio"][name="${currentSelected.getAttribute('name')}"]`);
                listenAnotherOption(optionSelects);
            }
        })
    }

    function listenAnotherOption(optionSelects) {
        optionSelects.forEach(function (item){
            item.addEventListener('change', function (){
                setTimeout(function (){
                    checkPersonalizationField();
                }, 100);
            })
        })
    }

    // listen change size option
    function personalizationListener(optionSelects){
        optionSelects.forEach(function (item){
            item.addEventListener('change', function (event){
                if (personalizationTriggerValues.includes(event.target.dataset.value.toLowerCase())) {
                    personalizationTextBlock.classList.add('active');
                } else {
                    personalizationTextBlock.classList.remove('active');
                    document.getElementById('personalization-info').value = '';
                }

                setTimeout(function (){
                    checkPersonalizationField();
                }, 100);

                setTimeout(function (){
                    setPersonalization();
                },500)
            })
        })

        // Listen personalizationText
        personalizationText.addEventListener('input', function (event) {
            checkPersonalizationField();
        });

        checkPersonalizationField();
    }

    function isEmptyPersonalizationField() {
        if (personalizationText.value.length < 2) {
            return true;
        } else {
            return false;
        }
    }

    // disable button if field empty
    function checkPersonalizationField() {
        let buttons = document.querySelectorAll('.product-form__buttons button');

        setTimeout(function (){
            if (personalizationTextBlock.classList.contains('active')) {
                if (isEmptyPersonalizationField()) {
                    buttons.forEach(function (item){
                        item.setAttribute('disabled', 'disabled');
                        personalizationTextBlock.classList.add('error');
                    })
                } else {
                    buttons.forEach(function (item){
                        item.removeAttribute('disabled');
                        personalizationTextBlock.classList.remove('error');
                    })
                }
            }
        },600)
    }
})